//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import { handleImgSize } from '@/common/utils/map_view_data'
import CommonFooter from '../_components/_common_footer'
import AudioPlayer from '../img_preview/_audio_player'
import audio from '../img_preview/mixin/audio'
import vr_tip from '../img_preview/mixin/vr_tip'
import ImgTools from '../img_preview/_img_tools'
import VrTip from '../img_preview/_vr_tip'
import building_like_tip from '../mixins/building_like_tip'
import PhoneTip from '../_components/_phone_tip'
import LikeTip from '../_components/_like_tip'
import Layout from '../_components/_layout'
import SubscribeSuccess from '../_components/_subscribe_success'
import detailSubPage from '@/common/mixins/detailSubPage'
import LayoutTip from '@/views/building/_components/_layout_tip'
export default {
    components: {
        PhoneTip,
        LikeTip,
        SubscribeSuccess,
        CommonFooter,
        ImgTools,
        AudioPlayer,
        LayoutTip,
        VrTip,
        Layout
    },
    mixins: [
        audio,
        vr_tip,
        building_like_tip,
        detailSubPage
    ],
    data () {
        return {
            building_id: '',
            layout_id: '',
            item: {},
            house: {
                name: ''
            },
            layout_items: []
        }
    },
    computed: {
        preview_img () {
            return this.item && this.item.image_url ? handleImgSize(this.item.image_url, 750, 600)  : ''
        },
        show_disclaimer () {
            return this.house.activities && this.house.activities.indexOf('vr_disclaimer') > -1
        },
        tag_list () {
            return this.item.tag_list && this.item.tag_list.slice(0, 3)
        }
    },
    mounted () {
        const { building_id, layout_id } = this.$route.query
        this.building_id = building_id
        this.layout_id = layout_id
        this.getData()
    },
    watch: {
        '$route' (to, from) {
            this.$router.go(0);
        }
    },
    methods: {
        preview () {
            const image_url = handleImgSize(this.item.image_url, 1125, 1800)
            this.$wx.previewImage({
                current: image_url,
                urls: [image_url]
            })
        },
        async getHouse () {
            const building = await Service.getBuilding(this.building_id, {})
            building.favourite = building.follow_info && building.follow_info.id
            this.house = building
        },
        async getData () {
            await this.getHouse()
            const detailParam = encodeURIComponent(`building_id=${this.building_id}`)
            const data = await Service.layoutDetail(this.building_id, this.layout_id)
            this.item = data
            // todo
            data.vr_url = ''
            if (data.vr_url) {
                this.vr_link = `/building/web_vr?building_id=${this.building_id}&link=${encodeURIComponent(data.vr_url)}&title=${this.house.name}&detailParam=${detailParam}&category_id=${data.id}`
            }
            this.resetAudioPlaying([data])
            this.getLayouts()
        },
        async getLayouts () {
            const data = await Service.getImgs(this.building_id, 'layout', {})
            this.layoutItemsSort(data.items)
        },
        layoutItemsSort(items) {
            const house_ids = this.house.current_houses.map(({ id }) => id)
            const current_urls = items.sort(
                (a, b) => {
                    return house_ids.indexOf(a.house_id) > -1 && house_ids.indexOf(b.house_id) === -1
                    ? -1 : 1
                }
            ).map((item) => {
                return {
                    ...item,
                    vr_url: ''
                }
            })
            this.layout_items = current_urls.filter(({ id }) => id != this.layout_id)
        },
        openLayoutDetail (id) {
            this.$router.push({
                path:`/building/layout_detail?building_id=${this.building_id}&layout_id=${id}`
            })
        },
        goVideo (src) {
            const { id, name } = this.house
            this.$router.push({
                path:`/building/video?building_id=${id}&title=${name}&src=${this.item.video_url}`
            })
        },
        play () {
            this.playAudio(0, this.item.audio_url)
        },
        stop () {
            this.stopAudio(0)
        },
        seek (percent) {
            this.seekAudio(percent)
        },
        changeFavourite() {
            this.toggleFavourite('户型图详情页——关注')
            this.getHouse()
        },
        goLayout() {
            const { building_id, name } = this.house
            this.$router.push({
                path:`/building/img_preview?type=layout&title=${name}&building_id=${building_id || ''}`
            })
        },
        goPrice() {
            const {building_id, name } = this.house
            const {id, price_house_id } = this.item
            wx.navigateTo({
                url:`/building/price?building_id=${building_id}&title=${name}&house_id=${price_house_id}&building_image_id=${id}`
            })
        },
        openLayoutList () {
            const { building_id, name } = this.house
            this.$router.push({
                path:`/building/img_preview?house_id=&type=layout&title=${name}&building_id=${building_id || ''}`
            })
        }
    }
}
